exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "img[data-v-84345af2]{max-width:100%}img.floorplan-img[data-v-84345af2]{width:800px;display:block;margin-left:auto;margin-right:auto}i.description[data-v-84345af2]{white-space:pre-line}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-84345af2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./assets/vue/logger/JobPost.vue
// module id = 513
// module chunks = 0